import { Message } from '../../domain';

type MessageBubbleProps = {
  message: Message;
};

export function MessageBubble({ message }: MessageBubbleProps) {
  const isUser = message.role === 'user';

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-5`}>
      <div
        className={`max-w-full rounded-2xl px-4 py-3 text-sm leading-relaxed shadow-sm border sm:max-w-[85%] sm:px-5 sm:py-4 lg:max-w-[65%] ${
          isUser
            ? 'bg-sky-600 text-white border-sky-500'
            : 'bg-slate-900 text-slate-100 border-slate-800'
        }`}
      >
        <p className="whitespace-pre-wrap">{message.content}</p>
        {!isUser && message.context && message.context.length > 0 && (
          <div className="mt-4 space-y-2 text-xs text-slate-300">
            <p className="uppercase tracking-wide text-[10px] text-slate-400">Context</p>
            {message.context.map((chunk) => (
              <details
                key={`${message.id}-${chunk.doc_name}-${chunk.chunk_id}`}
                className="rounded-xl border border-slate-700 bg-slate-950/60 p-3"
              >
                <summary className="cursor-pointer text-slate-100">
                  {chunk.doc_name} - chunk {chunk.chunk_id} - score {chunk.score.toFixed(3)}
                </summary>
                <p className="mt-2 whitespace-pre-wrap text-slate-200">{chunk.text}</p>
              </details>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
